import {useEffect, useLayoutEffect, useRef} from "react";

export function useClickAway<T extends HTMLElement>(
  cb: () => void,
  ignoreRefs?: Array<React.RefObject<HTMLElement>>
): React.RefObject<T> {
  const ref = useRef<T>(null);
  const refCb = useRef(cb);

  useLayoutEffect(() => {
    refCb.current = cb;
  });

  useEffect(() => {
    const handler = (e: Event) => {
      const element = ref.current;
      const target = e.target as Element;

      if (!element || element.contains(target)) {
        return;
      }

      if (ignoreRefs?.some((ignoreRef) => ignoreRef.current?.contains(target))) {
        return;
      }

      refCb.current();
    };

    document.addEventListener("mousedown", handler);
    document.addEventListener("touchstart", handler);

    return () => {
      document.removeEventListener("mousedown", handler);
      document.removeEventListener("touchstart", handler);
    };
  }, []);

  return ref;
}
